import React from 'react';
import styles from './StandardOverview.module.css';

const IrlRequestProgress = ({ progress }) => {
    if (!progress) return null;

    const total = progress.answered + progress.inProgress + progress.outstanding;
    const pct = value => (total > 0 ? (value / total) * 100 : 0);

    if (progress.display === 'summary') {
        return (
            <>
                <div className={styles.progressTrack} aria-hidden>
                    <div className={styles.progressSegmentAnswered} style={{ width: `${pct(progress.answered)}%` }} />
                    {progress.inProgress > 0 ? (
                        <div className={styles.progressSegmentInProgress} style={{ width: `${pct(progress.inProgress)}%` }} />
                    ) : null}
                    {progress.outstanding > 0 ? (
                        <div className={styles.progressSegmentOutstanding} style={{ width: `${pct(progress.outstanding)}%` }} />
                    ) : null}
                </div>
                <p className={styles.cardDescriptionSmall}>{progress.summaryText}</p>
            </>
        );
    }

    return (
        <>
            <div className={styles.progressTrack} aria-hidden>
                <div className={styles.progressSegmentAnswered} style={{ width: `${pct(progress.answered)}%` }} />
                <div className={styles.progressSegmentInProgress} style={{ width: `${pct(progress.inProgress)}%` }} />
                <div className={styles.progressSegmentOutstanding} style={{ width: `${pct(progress.outstanding)}%` }} />
            </div>
            <div className={styles.progressLegend}>
                <span className={styles.progressLegendItem}>
                    <span className={`${styles.progressDot} ${styles.progressDotAnswered}`} />
                    {progress.answered} answered
                </span>
                <span className={styles.progressLegendItem}>
                    <span className={`${styles.progressDot} ${styles.progressDotInProgress}`} />
                    {progress.inProgress} in progress
                </span>
                <span className={styles.progressLegendItem}>
                    <span className={`${styles.progressDot} ${styles.progressDotOutstanding}`} />
                    {progress.outstanding} outstanding
                </span>
            </div>
        </>
    );
};

export default IrlRequestProgress;
